import SignupContainer from "../../containers/signup";

const SignupPage = () => {
  return <SignupContainer />;
};

export default SignupPage;